"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utoh = exports.utoa = exports.btoa = void 0;
const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function btoa(string) {
    let result = '';
    for (let i = 0; i < string.length;) {
        const a = string.charCodeAt(i++);
        const b = string.charCodeAt(i++);
        const c = string.charCodeAt(i++);
        if (a > 255 || b > 255 || c > 255) {
            throw new TypeError('Failed to encode base64: The string to be encoded contains characters outside of the Latin1 range.');
        }
        const bitmap = (a << 16) | (b << 8) | c;
        result +=
            b64.charAt((bitmap >> 18) & 63) +
                b64.charAt((bitmap >> 12) & 63) +
                b64.charAt((bitmap >> 6) & 63) +
                b64.charAt(bitmap & 63);
    }
    const rest = string.length % 3;
    return rest ? result.slice(0, rest - 3) + '==='.substring(rest) : result;
}
exports.btoa = btoa;
function utoa(string) {
    return btoa(unescape(encodeURIComponent(string)));
}
exports.utoa = utoa;
function utoh(string) {
    return utoa(string).replace(/\+/g, '-').replace(/\//g, '_');
}
exports.utoh = utoh;
